(() => {
  const instances = new Map();

  function mount(info) {
    if (instances.has(info)) return;
    const section = info.closest('[data-cb-stable-purchase]');
    if (!section) return;
    const id = info.dataset.source;
    const bar = section.querySelector('#product-sticky-bar-' + id);
    const price = section.querySelector('#price-' + id);
    const form = section.querySelector('product-form[data-source="' + id + '"]');
    const submit = form?.querySelector('[type="submit"]');
    const buy = form?.closest('.cb-buy-form');
    const benefits = info.querySelector('.inventory-delivery');
    if (!bar || !price || !submit || !buy) return;

    // The real form, price and stock status stay in their server-rendered positions.
    // Only this fixed overlay is hidden at the handover; no in-flow element moves.
    const events = new AbortController();
    const media = window.matchMedia('(max-width: 989px)');
    const proxy = document.createElement('button');
    proxy.type = 'button';
    const stickyPrice = document.createElement('div');
    stickyPrice.className = price.className;
    stickyPrice.setAttribute('aria-hidden', 'true');
    const stickyBenefits = document.createElement('div');
    stickyBenefits.className = 'inventory-delivery';
    stickyBenefits.setAttribute('aria-hidden', 'true');

    function mirrorChildren(source, target) {
      const copy = source.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      copy.querySelectorAll('[role="status"], [aria-live]').forEach(node => {
        node.removeAttribute('role');
        node.removeAttribute('aria-live');
      });
      copy.querySelectorAll('.cb-product-klarna').forEach(node => node.remove());
      target.replaceChildren(...copy.childNodes);
    }

    function syncContent() {
      proxy.className = submit.className + ' cb-sticky-submit';
      proxy.disabled = submit.disabled;
      for (const attr of ['aria-disabled', 'aria-busy', 'aria-haspopup', 'aria-label']) {
        if (submit.hasAttribute(attr)) proxy.setAttribute(attr, submit.getAttribute(attr));
        else proxy.removeAttribute(attr);
      }
      mirrorChildren(submit, proxy);
      mirrorChildren(price, stickyPrice);
      if (benefits) mirrorChildren(benefits, stickyBenefits);
      schedule();
    }

    proxy.addEventListener('click', () => {
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      // Use the original button so variant, frame add-on and cart handlers remain authoritative.
      submit.click();
    }, {signal: events.signal});

    let frame = 0;
    function syncPosition() {
      frame = 0;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const reached = buy.getBoundingClientRect().top <= bottom - bar.getBoundingClientRect().height;
      const hidden = !media.matches || reached;
      bar.classList.toggle('product-sticky-bar--hidden', hidden);
      bar.inert = hidden;
      bar.setAttribute('aria-hidden', String(hidden));
      bar.style.bottom = Math.max(0, window.innerHeight - bottom) + 'px';
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(syncPosition);
    }

    bar.replaceChildren(proxy, stickyPrice, ...(benefits ? [stickyBenefits] : []));
    syncContent();
    const observer = new MutationObserver(syncContent);
    for (const node of [submit, price, benefits].filter(Boolean)) {
      observer.observe(node, {subtree: true, childList: true, characterData: true, attributes: true});
    }
    const resize = new ResizeObserver(schedule);
    for (const node of [bar, buy, info, section]) resize.observe(node);
    window.addEventListener('scroll', schedule, {passive: true, signal: events.signal});
    window.addEventListener('resize', schedule, {passive: true, signal: events.signal});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true, signal: events.signal});
    window.visualViewport?.addEventListener('scroll', schedule, {passive: true, signal: events.signal});
    media.addEventListener('change', schedule, {signal: events.signal});
    syncPosition();

    instances.set(info, () => {
      events.abort();
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      bar.replaceChildren();
    });
  }

  function init() {
    document.querySelectorAll('.product__info-container[data-source]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, info) => {
      if (event.target.contains(info)) { dispose(); instances.delete(info); }
    });
  });
})();
